import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function FAQ() {
  return (
    <div className="min-h-screen bg-background px-4 sm:px-6 lg:px-8 animate-fade-in">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold tracking-tight text-foreground">
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-muted-foreground">
            Have more questions?{" "}
            <Link to="/support" className="text-primary hover:underline">
              Reach out to us
            </Link>
            .
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <Accordion type="single" collapsible className="w-full space-y-4">
            <AccordionItem value="item-1" className="border rounded-lg p-2">
              <AccordionTrigger className="text-left hover:no-underline">
                Are there any limitations on the number of videos I can engage with on MindTube?
              </AccordionTrigger>
              <AccordionContent>
                New users can interact with up to 3 videos per day, which resets daily. Essential plan users can engage with 30 videos per day, while Pro users enjoy unlimited video conversations.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2" className="border rounded-lg p-2">
              <AccordionTrigger className="text-left hover:no-underline">
                Can I review my conversation history?
              </AccordionTrigger>
              <AccordionContent>
                Yes! All chat interactions are saved, so you can pick up where you left off. We've also added a video history feature to help you revisit past conversations effortlessly.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3" className="border rounded-lg p-2">
              <AccordionTrigger className="text-left hover:no-underline">
                Is MindTube actively maintained?
              </AccordionTrigger>
              <AccordionContent>
                Yes! We constantly refine MindTube based on user feedback. Share your thoughts, and we'll work on enhancing the experience for you.
              </AccordionContent>
            </AccordionItem>
          </Accordion>

          <Accordion type="single" collapsible className="w-full space-y-4">
            <AccordionItem value="item-4" className="border rounded-lg p-2">
              <AccordionTrigger className="text-left hover:no-underline">
                Does it work across all browsers?
              </AccordionTrigger>
              <AccordionContent>
                MindTube works best on Chromium-based browsers like Chrome and Edge. If you're using Firefox, Safari, or others, you can access MindTube via our web platform on all devices.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-5" className="border rounded-lg p-2">
              <AccordionTrigger className="text-left hover:no-underline">
                Can I submit feature suggestions?
              </AccordionTrigger>
              <AccordionContent>
                Absolutely! We welcome your ideas. New users can even access a one-month free trial of the Essential plan for submitting feedback. Share your suggestions with us through our feedback portal.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-6" className="border rounded-lg p-2">
              <AccordionTrigger className="text-left hover:no-underline">
                How does MindTube generate intelligent conversations from YouTube videos?
              </AccordionTrigger>
              <AccordionContent>
                MindTube's Claude AI to analyze video content and delivers real-time insights, discussions, and summaries tailored to the video's subject matter—giving you instant access to the knowledge you need.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>

        <div className="text-center pb-8">
          <Button asChild className="gap-2">
            <Link to="/support">
              <MessageCircle className="w-4 h-4" />
              Contact our support team
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
